var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticStyle:{"font-family":"'Noto Sans KR', sans-serif"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }